import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useCallback } from "react";

export const ADD_PRODUCT_TO_COLLECTION = gql`
  mutation addProductsToCollection($collectionId: ID!, $productIds: [Int!]) {
    addProductsToCollection(
      collectionId: $collectionId
      productIds: $productIds
    )
  }
`;

const useAddProductsToCollection = () => {
  const [addProductsToCollectionMutation, { loading, data }] = useMutation(
    ADD_PRODUCT_TO_COLLECTION
  );

  const addProductsToCollection = useCallback(
    (collectionId: string, productIds: number[]) => {
      return addProductsToCollectionMutation({
        variables: { collectionId, productIds },
        optimisticResponse: true,
      });
    },
    [addProductsToCollectionMutation]
  );

  return { addProductsToCollection, loading, data };
};

export { useAddProductsToCollection };
